// import type { RebookingResponse } from 'wagAPI';
// import type { RebookingParsedResponse } from 'webApp';
export const rebookingResponseParser = (response: any): any => ({ ...response
});
export default rebookingResponseParser;